<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
>
    <v-card>
        <v-card-title>New drip message</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="label"
                autocomplete="off"
            />

            <v-select
                label="Send From"
                v-model="send_from"
                :items="send_from_choices"
            />

            <m-edit-text
                label="Time to wait after a member is added to a list before sending"
                v-model="list_drip_delay"
                duration
            />

            

            <m-edit-message-patterns
                    v-model="message_patterns"
                    context="list-drip"
                />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Create
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            list_drip_delay: 24*60*60*1000,
            label: 'Your label here',
            message_patterns: ['Hi {first-name}, your message here!'],
            organization_id: null,
            list_id: null,  
            send_from_choices: [], 
            send_from: null,
        }
    },

    methods: {

        showDialog(organization_id, list_id, send_from)
        {
            this.organization_id = organization_id;
            this.list_id = list_id;
            this.send_from = send_from;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/numbers/send-from-choices/:organization_id',
            
                'params' : {
                        'organization_id': organization_id,
                    },
            
                'on_success': (data) => {
                        this.send_from_choices = data.send_from_choices;
                        this.dialog = true;
                    },
            
                'on_error': 'Unable to get send from number choices',
            });
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/lists/quick-drip-message-create',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'list_id': this.list_id,
                        'label': this.label,
                        'message_patterns': this.message_patterns,
                        'list_drip_delay': this.list_drip_delay,
                        'send_from': this.send_from,
                    },
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('ok');
                    },
            
                'on_error': 'Unable to create drip message',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        is_valid() {
            return this.send_from != null;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>